import React, { useState } from "react";
import { Paper, withStyles } from "@material-ui/core";
import { Row, Col } from "react-flexbox-grid";
import TagsTable from "./tagsTable";
import { Mutation, Query } from "react-apollo";
import gql from "graphql-tag";
import PropTypes from "prop-types";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import TagsAddForm from "./tagsAddForm";
import { useApollo } from "apollo";

const LOAD_TAGS = gql`
  query {
    tags {
      id
      name
    }
  }
`;

const GET_TAGS = gql`
  {
    tags {
      id
      name
      description
    }
  }
`;

const ADD_TAG = gql`
  mutation addIndicatorType($tag: TagInput!) {
    createTag(tag: $tag) {
      id
      name
      description
    }
  }
`;

const UPDATE_ADD = gql`
  mutation($id: ID!, $tag: TagInput!) {
    updateTag(tagId: $id, tag: $tag) {
      id
      name
      description
    }
  }
`;

const styles = theme => ({
  root: {
    position: "relative",
    margin: 36
  },
  fab: {
    position: "absolute",
    top: 0,
    right: 0,
    transform: `translateX(${50}%) translateY(${-50}%)`
  }
});

/**
 * Componente para el listado de Tags
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0
 */
const TagsList = ({ classes }) => {
  const { tags: client } = useApollo();
  const [openAdd, setOpenAdd] = useState(false);
  const [objectAction, setObjectAction] = useState(null);
  const [mutation, setMutation] = useState(ADD_TAG);

  function handleOpenEdit(row) {
    setObjectAction(row);
    setOpenAdd(!openAdd);
    setMutation(UPDATE_ADD);
  }

  function handleClose() {
    setObjectAction(null);
    setOpenAdd(false);
    setMutation(ADD_TAG);
  }

  return (
    <Mutation
      mutation={mutation}
      refetchQueries={() => [{ query: GET_TAGS }, {query : LOAD_TAGS}]}
      onCompleted={() => handleClose()}
      client={client}
    >
      {postMutation => {
        return (
          <Query query={GET_TAGS} client={client}>
            {({ loading, error, data }) => {
              if (loading) return null;
              if (error) return `Error!: ${error}`;
              return (
                <Row>
                  <Col xs={12}>
                    <Paper className={classes.root}>
                      <Fab className={classes.fab} color={"primary"} onClick={() => setOpenAdd(true)}>
                        <AddIcon />
                      </Fab>
                      <TagsTable data={data} openEdit={row => handleOpenEdit(row)} query={GET_TAGS} client={client} />
                    </Paper>
                    {openAdd && (
                      <TagsAddForm
                        open={openAdd}
                        handleOpen={() => setOpenAdd(!openAdd)}
                        onClose={() => handleClose()}
                        onSubmit={postMutation}
                        objectEdit={objectAction}
                      />
                    )}
                  </Col>
                </Row>
              );
            }}
          </Query>
        );
      }}
    </Mutation>
  );
};

TagsList.propTypes = {
  classes: PropTypes.object,
  client: PropTypes.func
};

export default withStyles(styles)(TagsList);



// WEBPACK FOOTER //
// ./src/components/tags-manager/resources-tags/tagsList.js